import { Component, OnInit } from '@angular/core';
import 'rxjs/add/observable/of';
import { TokenStorage } from 'src/app/auth/token.storage';

@Component({
  selector: 'app-fleet',
  templateUrl: './fleet.component.html',
  styleUrls: ['./fleet.component.scss']
})
export class FleetComponent implements OnInit {

  mapView: boolean = false;
  link = '/fleet';

  constructor(
    private tokenStorage: TokenStorage
  ) { }

  ngOnInit() {
    if(this.tokenStorage.getCustomerType() == 'Diagnostic') {
      this.link = '/trip';
      this.mapView = true;
    }
  }

  toogleView() {
    if (!this.mapView) {
      this.mapView = true;
      console.log(this.mapView);
    } else {
      this.mapView = false
      console.log(this.mapView);
    }
  }
}